import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import OrderUserContext from "../OrderUserContext"; // Adjust the path to your context
import {
  faCalendarDays,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
const OrderDetails = () => {
  const { orderId } = useParams(); // Get the orderId from URL
  const { customer } = useContext(OrderUserContext); // Access customer from context

  // Find the order based on the orderId
  const order = customer
    .flatMap((customerData) => customerData.orders)
    .find((order) => order.orderId === orderId);


  // Find the customerData associated with this order
  const customerData = customer.find((customer) =>
    customer.orders.some((custOrder) => custOrder.orderId === orderId)
  );
  // Extract delivery address
  const deliveryAddress = order?.deliveryAddress;

  if (!order) {
    return   <div
    className="relative h-[100vh] flex items-center justify-center"
    style={{ position: "relative", height: "100vh" }}
  >
    <div
      className=" flex items-center justify-center"
      style={{
        position: "absolute",
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <RotatingLines
        visible={true}
        height="150"
        width="150"
        color="red"
        strokeColor="#24425a"
        strokeWidth="5"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  </div>;
  }
  else{
    const formattedDate = new Date(order.createdAt).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    return (
      <div className="order-details">
        <Container fluid>
          <div className="d-flex gap-2 ps-3 pt-3">
            <h5>
              <Link to="/All-Orders">ORDERS</Link>
            </h5>
            <span>/</span>
            <span>Order details</span>
          </div>
          <div className="ps-3 d-flex gap-5">
            <h4>{order.orderId.toUpperCase()}</h4>
            <span className="text-[#677788]">
              <FontAwesomeIcon icon={faCalendarDays} /> {formattedDate}{" "}
            </span>
          </div>
          <hr />
          <div className="row p-1 gap-4">
            <div className="col-xl-8 col-md-12 col-sm-12  border rounded-lg ">
              <h5 className="my-2 border-b-2 py-2 d-flex">
                Order details{" "}
                <span
                  style={{
                    backgroundColor: "rgb(231 232 236)",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  {order.products.length}
                </span>
              </h5>
              <div>
                <Container fluid>
                  <Row className="d-flex justify-content-center align-items-center py-3 font-['poppins']">
                    {order.products.map((product, index) => (
                      <React.Fragment key={index}>
                        <Col lg={6} className="d-flex gap-5">
                          <div className="my-2 w-[180px]">
                            <img
                              src={product.imageurl}
                              alt=""
                              style={{ width: "100%", height: "150px" }}
                            />
                          </div>
                          <div>
                            <p>
                              {/* <Link to=''> */}
                                <b className="uppercase">{product.title}</b>
                              {/* </Link> */}
                            </p>
                            <p>Category: {product.category}</p>
                            <p>Sub Category: {product.subcategory || "NEW"}</p>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div>
                            <b>₹ {product.originalPrice}/-</b>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div>
                            <b>{product.quantity}</b>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div>
                            <b>₹ {product.originalPrice * product.quantity}/-</b>
                          </div>
                        </Col>
                      </React.Fragment>
                    ))}
                  </Row>
                  <hr />
                  <Row>
                    <Col lg={8}></Col>
                    <Col lg={4}>
                      <Row>
                        <Col lg={6}>
                          <p>subTotal:</p>
                        </Col>
                        <Col lg={6}>
                          <p>
                            ₹{" "}
                            <b>
                              {order.products.reduce(
                                (total, product) =>
                                  total +
                                  product.originalPrice * product.quantity,
                                0
                              )}
                            </b>
                            /-
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <p>Shipping fee:</p>
                        </Col>
                        <Col lg={6}>
                          <p>
                            ₹ <b>0</b>/-
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <p>Total:</p>
                        </Col>
                        <Col lg={6}>
                          <p>
                            ₹{" "}
                            <b>
                              {order.products.reduce(
                                (total, product) =>
                                  total +
                                  product.originalPrice * product.quantity,
                                0
                              )}
                            </b>
                            /-
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <p>Amount paid:</p>
                        </Col>
                        <Col lg={6}>
                          <p>
                            ₹ <b>{order.totalPrice}</b>/-
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
            <div className="col-xl-3 col-md-12 col-sm-12 border rounded-lg">
              <h5 className="my-2 border-b-2 py-2 ">Customer</h5>
              <div>
                <div className="row p-2 my-2">
                  <div>
                   <Link to={`/customer-details/${customerData.customerId}`} className="text-decoration-none text-[#165987]">
                   <h4>{customerData?.orders.slice(0, 1).map(order =>
                        order.deliveryAddress?.name || customerData.name
                      )}</h4>
                   </Link>{" "}
                  </div>
                </div>
                <hr />
                <h5>
                  <FontAwesomeIcon
                    icon={faCartShopping}
                    className="text-[25px] pe-3"
                  />{" "}
                  <Link to={`/customer-details/${customerData.customerId}`} className="text-decoration-none text-[green]">
                    <span>{customerData?.orders?.length || 0} orders</span>
                  </Link>{" "}
                </h5>
                <hr />
                <div className="row my-2">
                  <div>
                    <p>
                      <b>Contact Info :</b>
                    </p>
                    <p>Email: {customerData?.orders.slice(0, 1).map(order =>
                        order.deliveryAddress?.email || customerData.email
                      )}</p>
                    <p>Number: {customerData?.phoneNumber}</p>
                  </div>
                </div>
                <hr />
                <div className="row my-2">
                  <div>
                    <p>
                      <b>Delivery Address:</b>
                    </p>
                    <p>Address: {deliveryAddress?.address}</p>
                    <p>City: {deliveryAddress?.city}</p>
                    <p>State: {deliveryAddress?.state}</p>
                    <p>Pincode: {deliveryAddress?.pincode}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  
 
};

export default OrderDetails;
